import { render, staticRenderFns } from "./ModalOffTalent.vue?vue&type=template&id=651ab99e&scoped=true&"
import script from "./ModalOffTalent.vue?vue&type=script&lang=js&"
export * from "./ModalOffTalent.vue?vue&type=script&lang=js&"
import style0 from "./ModalOffTalent.vue?vue&type=style&index=0&id=651ab99e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651ab99e",
  null
  
)

export default component.exports